import Vue from 'vue';
import App from './App.vue';

import './assets/css/reset.css';
import './assets/css/public.css';
// import './assets/eventBus.js';

import axios from 'axios';
import router from './router';
import store from './store';

Vue.prototype.$http = axios;

Vue.config.productionTip = false;

Vue.prototype.resetSetItem = function (key, newVal) {
    if (key === '__token') {
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
                sessionStorage.setItem(k, val);
 
                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
 
                // 派发对象
                window.dispatchEvent(newStorageEvent);
            }
        };
        return storage.setItem(key, newVal);
    }
};


Vue.directive('visible', (el, binding) => {
    let show = binding.value;
    if (!(!show)) {
        el.style.visibility = 'visible';
    } else {
        el.style.visibility = 'hidden';
    }
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
